// extracted by mini-css-extract-plugin
export default {"wrap":"bI-z","fullWidth":"cI-z","hideOnDesktop":"dI-z","content":"eI-z","hasOpenedNav":"fI-z","crumbsList":"gI-z","dropdownsWrap":"hI-z"};